export function isValidGitPathSegment(segment: string): boolean {
  return !(
    !segment ||
    segment === "." ||
    segment === ".." ||
    segment.toLowerCase() === ".git" ||
    segment.includes("\\") ||
    segment.includes("\0")
  );
}

export function isValidGitPath(path: string): boolean {
  return path.split("/").every(isValidGitPathSegment);
}
